import React, { useState } from "react";
import error from "../../assets/icon/error.svg";
import close from "../../assets/icon/close-small.svg";
import { useEffect } from "react";

const Textarea = ({
  id,
  name,
  value = "",
  maxLength,
  placeholder,
  onChange,
  warningMessage,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [characterCount, setCharacterCount] = useState("");
  const [inputValue, setInputValue] = useState("");

  // const handleChange = (event) => {
  //   if (maxLength && event.target.value.length <= maxLength) {
  //     const text = event.target.value;
  //     setCharacterCount(text);
  //     setErrorMessage("");
  //   } else {
  //     setErrorMessage(`Exceeded ${maxLength} characters`);
  //   }
  // };
  const setValueNull = () => {
    const customEvent = {
      target: {
        name: name,
        value: "",
      },
    };
    onChange(customEvent);
  };
  // const setValueNull = () => {
  //   setInputValue("");
  // };

  useEffect(() => {
    if (inputValue?.length > maxLength) {
      setErrorMessage(true);
    } else {
      setErrorMessage(false);
    }
    setInputValue(value);
  }, [value]);

  return (
    <div>
      <div className="textarea-box ">
        <textarea
          id={id}
          name={name}
          placeholder={placeholder}
          className="w-100"
          onChange={onChange}
          value={value}
          maxLength={maxLength}
        />
        {value?.length > maxLength ? (
          <div>
            <img src={error} alt="error" className="abouterror" />
          </div>
        ) : (
          <></>
        )}
        {value?.length > 0 && value?.length < maxLength ? (
          <div>
            <img
              src={close}
              alt="close"
              className="abouterror pointer ps-1"
              onClick={setValueNull}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <p className="warning w-100 ps-1">
          {/* Max. {maxLength} characters for about section */}
          {warningMessage}
        </p>

        <label
          htmlFor=""
          className="medium word-counter w-100 d-flex justify-content-end"
        >
          {value?.length} / {maxLength}
        </label>
      </div>
    </div>
  );
};

export default Textarea;
